import React from 'react';
import '../App.css';

import { Navbar, Bitcoin_header, Bitcoin_autores, Bitcoin_descubre, Bitcoin_recomendado, Bitcoin_donde, Bitcoin_grafica, Bitcoin_registro, Footer } from '../container';
import { PopupContainer } from "../container/LibroBitcoin/PopupContainer/PopupContainer";
import { PopupProvider } from "../context/PopupProvider";

const LibroBitcoin = () => {


    return (
        <PopupProvider>
            <div class="App_DB landing_bitcoin_principal">
                <PopupContainer />
                <Navbar link2='#donde-comprar' />
                <Bitcoin_header />
                <Bitcoin_autores />
                <Bitcoin_descubre />
                <Bitcoin_recomendado />
                <Bitcoin_donde />
                <Bitcoin_registro />
                <Bitcoin_grafica />
                <Footer />


            </div>
        </PopupProvider>
    )

}

export default LibroBitcoin;